export default __webpack_public_path__ + "static/media/z2jmzra0.fb6972d2.jpg";